import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// istanbul ignore next
const Input = ({
  type,
  size,
  style,
  error,
  placeholder,
  extraClass,
  name,
  required,
  ariaLabel,
  value,
  min,
  max,
  step,
  onChange,
  onMouseDown,
  onMouseUp,
  onInput,
  onKeyUp,
  testAttribute,
}) => {
  const inputCssClass = classNames('input', {
    [`input--${size}`]: size,
    [`input--${style}`]: style,
    'input--error': error,
    [`${extraClass}`]: extraClass,
  });

  const ownProps = {
    'aria-label': ariaLabel,
    className: inputCssClass,
    placeholder,
    name,
    required,
    value,
    min,
    max,
    step,
    onChange,
    onMouseDown,
    onMouseUp,
    onInput,
    onKeyUp,
  };

  if (type === 'textarea') {
    return (
      <Fragment>
        <textarea {...ownProps} data-test={testAttribute} />
        {error && <span className="error">Error!!</span>}
      </Fragment>
    );
  }

  return (
    <Fragment>
      <input {...ownProps} data-test={testAttribute} type={type} />
      {error && <span className="error">Error!!</span>}
    </Fragment>
  );
};

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'number', 'password', 'range', 'textarea']).isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  style: PropTypes.string,
  error: PropTypes.bool,
  placeholder: PropTypes.string,
  extraClass: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  ariaLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onInput: PropTypes.func,
  onKeyUp: PropTypes.func,
  testAttribute: PropTypes.string,
};

export default Input;
